// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hover-link .la-facebook[data-v-df3816e0] {\n  color: #1973E7;\n}\n.hover-link .la-linkedin[data-v-df3816e0] {\n  color: #3378B6;\n}\n.hover-link .la-twitter[data-v-df3816e0] {\n  color: #47A2F2;\n}\n.hover-link .la-github[data-v-df3816e0] {\n  color: #000;\n}", ""]);
// Exports
module.exports = exports;
